import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';
import MyCollapse from 'components/Collapse';
import FileSelector from 'components/FileSelector';
import MaskedOutput from 'components/MaskedOutput';
import PermissionHide from 'components/PermissionHide';
import { WithStyles } from 'decorators/withStyles';
import React, { Fragment, PureComponent } from 'react';
import { FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';
import { closeDetails, loadFiles, loadUrlDownload } from 'store/Orbita/FiscalDocuments/actions';
import { upload } from 'store/Orbita/Upload/actions';

import Customer from './Customer';
import Files from './Files';
import Items from './Items';

import type { ICDFList } from 'store/Orbita/FiscalDocuments/interfaces';

interface IPropsFromConnect {
  active: boolean;
  data: ICDFList[0]['list'][0];

  upload?: typeof upload;
  closeDetails?: typeof closeDetails;
  loadFiles?: typeof loadFiles;
  loadUrlDownload?: typeof loadUrlDownload;
  classes?: any;
  urlDownload?: any;
}

interface IState {
  uploading: boolean;
  downloading: boolean;
}

@WithStyles({
  iconClose: { fontSize: '16x', color: '#ccc' },
  button: { textAlign: 'right' },
  progress: { marginRight: 10 },
})
class QuickView extends PureComponent<IPropsFromConnect, IState> {
  fileSelector: React.RefObject<FileSelector>;

  eduzzEmitterIds: Array<Number> = [70042526, 52584, 63545352];

  constructor(props: IPropsFromConnect) {
    super(props);
    this.state = { uploading: false, downloading: false };
    this.fileSelector = React.createRef();
  }

  get containerClass() {
    return `my-quickview ${this.props.active ? ' -active ' : ''}`;
  }

  get overlayClass() {
    return `my-overlay ${this.props.active ? ' -active ' : ''}`;
  }

  handleClose = () => {
    this.props.closeDetails();
  };

  handleSelectFile = async () => {
    const file = await this.fileSelector.current.open();

    if (!file) return;

    this.setState({ uploading: true });
    await this.props.upload(file, 'doc_fiscais', null, this.props.data.id);
    this.setState({ uploading: false });

    this.props.loadFiles(this.props.data.id);
  };

  handleClickDownload = async () => {
    this.setState({ downloading: true });
    await this.props.loadUrlDownload(this.props.data.id);
    this.setState({ downloading: false });

    let linkDownload = this.props.urlDownload[0].url;
    window.open(linkDownload, '_blank');
  };

  render() {
    const { uploading, downloading } = this.state;
    const { data, active, classes } = this.props;

    return (
      <Fragment>
        <FileSelector ref={this.fileSelector} />

        <div className={this.containerClass}>
          <div className='my-quickview__head'>
            <Grid container justify='space-between' alignItems='center'>
              <div className='my-quickview__title'>COD. {data.id}</div>

              <div className='my-quickview__close' onClick={this.handleClose}>
                <Icon className={classes.iconClose}>clear</Icon>
              </div>
            </Grid>
          </div>

          {active && (
            <div className='my-quickview__container'>
              <Typography>
                {data.status} -&nbsp;
                <MaskedOutput mask='date' value={data.reference_date} />
              </Typography>
              <Typography variant='h6'>{data.display}</Typography>
              <Typography variant='subtitle1'>
                <FormattedNumber value={data.value || 0} format='BRL' />
              </Typography>

              <div className='m24' />

              <MyCollapse title='Origem' arrow>
                <Customer data={data.customer_origin} />
              </MyCollapse>

              <div className='m8' />

              <MyCollapse title='Destino' arrow>
                <Customer data={data.destination_customer} />
              </MyCollapse>

              <div className='m8' />

              <MyCollapse title='Detalhes' arrow>
                <Items />
              </MyCollapse>

              <div className='m8' />

              <MyCollapse title='Arquivos' arrow>
                <Files />
              </MyCollapse>

              {!this.eduzzEmitterIds.includes(data.customer_origin.id) && (
                <PermissionHide action='myeduzz:cdf:editar'>
                  <div className='m8' />

                  <div className={classes.button}>
                    <Button disabled={uploading} onClick={this.handleSelectFile}>
                      {uploading && <CircularProgress className={classes.progress} size={15} />}
                      {uploading ? 'Enviando...' : 'Upload de Arquivo'}
                    </Button>
                  </div>
                </PermissionHide>
              )}

              <div className='m8' />

              {this.eduzzEmitterIds.includes(data.customer_origin.id) && (
                <div className={classes.button}>
                  <Button disabled={downloading} onClick={this.handleClickDownload}>
                    {downloading && <CircularProgress className={classes.progress} size={15} />}
                    {downloading ? 'Baixando...' : 'Download'}
                  </Button>
                </div>
              )}
            </div>
          )}
        </div>

        <div className={this.overlayClass} onClick={this.handleClose} />
      </Fragment>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    active: !!state.orbita.FiscalDocuments.details.data,
    data: state.orbita.FiscalDocuments.details.data || {},
    urlDownload: state.orbita.FiscalDocuments.urlDownload,
  };
}

export default connect<IPropsFromConnect, {}, {}>(mapStateToProps, {
  closeDetails,
  upload,
  loadFiles,
  loadUrlDownload,
})(QuickView);
